<template>

  <div>

    <list-add-new
      :is-add-new-sidebar-active.sync="isAddNewSidebarActive"
      @refetch-data="refetchData"
    />

    <list-edit-sidebar
      :is-list-edit-sidebar-active.sync = "isListEditSidebarActive"
      :edit-data = "details"
      @refetch-data="refetchData"
    />

    <!-- Filters -->
    <list-filters
      :status-filter.sync="statusFilter"
      :status-options="statusOptions"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                v-if="$can('create', 'Designation')"
                variant="primary"
                @click="isAddNewSidebarActive = true"
              >
                <span class="text-nowrap">Add Designation</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refListTable"
        class="position-relative"
        :items="fetchDatas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: index -->
        <template #cell(#)="data">
          <span class="text-center" :title="data.item.id">
              {{ data.index + 1 }}
          </span>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveStatusVariant(data.item.is_active)}`"
            class="text-capitalize"
          >
            {{ showStatus(data.item.is_active) }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item v-if="$can('edit', 'Designation')" @click="data.toggleDetails; detailsEdit(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item v-if="$can('delete', 'Designation') && data.item.is_active"  @click="changeStatus(data.item.id, 1)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Archive</span>
            </b-dropdown-item>

            <b-dropdown-item v-else if="$can('delete', 'Designation') && !data.item.is_active" @click="changeStatus(data.item.id, 0)">
              <feather-icon icon="RefreshCwIcon" />
              <span class="align-middle ml-50">Unarchive</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalData"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,BFormGroup, BInputGroup, BInputGroupAppend
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import ListFilters from './ListFilters.vue'
import useList from './useList'
import designationStoreModule from '../designationStoreModule'
import ListAddNew from './ListAddNew.vue'
import ListEditSidebar from './ListEdit.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    ListFilters,
    ListAddNew,
    ListEditSidebar,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,

    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      details: ''
    }
  },
  methods: {
    // change archive starus
    changeStatus(id, is_archived) {
      var status = is_archived ? 'archive' : 'unarchive'
      this.$swal({
        title: 'Are you confirm?',
        text: `You want to ${status} this!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('app-designation/changeStatus', {id: id, is_archived: is_archived})
            .then((response) => {
              if(response.data.status == 0 || response.data.status == 1){
                this.$swal({
                  icon: 'success',
                  title: response.data.message,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.refetchData();
              }
            })
          
        }
      })
    },
    detailsEdit(details_data) {
      this.details = details_data;
      this.isListEditSidebarActive = true;
    },
  },
  setup() {
    const DESIG_APP_STORE_MODULE_NAME = 'app-designation'

    // Register module
    if (!store.hasModule(DESIG_APP_STORE_MODULE_NAME)) store.registerModule(DESIG_APP_STORE_MODULE_NAME, designationStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(DESIG_APP_STORE_MODULE_NAME)) store.unregisterModule(DESIG_APP_STORE_MODULE_NAME)
    })

    const isAddNewSidebarActive = ref(false)
    const isListEditSidebarActive = ref(false)

    const statusOptions = [
      { label: 'All', value: null },
      { label: 'Active', value: "1" },
      { label: 'Archived', value: "0" },
    ]

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,

      // UI
      resolveStatusVariant,
      showStatus,

      // Extra Filters
      statusFilter,
    } = useList()

    return {

      // Sidebar
      isAddNewSidebarActive,
      isListEditSidebarActive,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,

      // UI
      resolveStatusVariant,
      showStatus,

      statusOptions,

      // Extra Filters
      statusFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
